import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="relative z-20 border-t border-white/10 mt-24 pt-10 pb-6 px-6 backdrop-blur-sm"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-6xl flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-white/40 text-center sm:text-left">
          © {new Date().getFullYear()} · The Secret Soulciety Club · All rites reserved
        </div>

        <div className="flex flex-wrap gap-x-8 gap-y-3 font-mono text-[10px] tracking-[0.35em] uppercase justify-center">
          <Link
            to="/terms"
            className="text-white/60 hover:text-cyan-400 transition"
            data-testid="footer-terms"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            className="text-white/60 hover:text-cyan-400 transition"
            data-testid="footer-privacy"
          >
            Privacy
          </Link>
          <Link
            to="/refund"
            className="text-white/60 hover:text-cyan-400 transition"
            data-testid="footer-refund"
          >
            Refunds
          </Link>
          <a
            href="mailto:secretsoulciety@secretsoulcietyclub.com"
            className="text-white/60 hover:text-cyan-400 transition"
            data-testid="footer-contact"
          >
            Contact
          </a>
        </div>
      </div>

      {/* Instagram + music credit — the last thing on the page */}
      <div className="mx-auto max-w-6xl mt-10 flex flex-wrap justify-center items-center gap-x-8 gap-y-3">
        <a
          href="https://instagram.com/secretsoulcietyclub"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="group flex items-center gap-3 font-mono text-[13px] tracking-[0.4em] uppercase text-fuchsia-400/90 hover:text-fuchsia-400 transition"
        >
          <Instagram className="w-10 h-10 shrink-0 group-hover:scale-110 transition-transform" strokeWidth={2} />
          @secretsoulcietyclub
        </a>
        <a
          href="https://instagram.com/z4n4r4"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-music-credit"
          className="group flex items-center gap-3 font-mono text-[13px] tracking-[0.4em] uppercase text-fuchsia-400/90 hover:text-fuchsia-400 transition"
        >
          Theme song by the high vibrational super star Zanara
          <Instagram className="w-10 h-10 shrink-0 group-hover:scale-110 transition-transform" strokeWidth={2} />
          @z4n4r4
        </a>
      </div>
    </footer>
  );
}
